// extracted by mini-css-extract-plugin
module.exports = {"selectedLanguage":"gnqQY _1R_Wx"};